import { shareHtmlUrl } from '@/services/company.js';
export default {
  mounted() {
    if (this.$route.query.to_component) {
      this.$nextTick(() => {
        setTimeout(() => {
          const element = document.getElementById(
            this.$route.query.to_component
          );
          element.scrollIntoView();
        }, 600);
      });
    }
  },
  methods: {
    exportRenderedHTML(elementId, companyId) {
      // document.querySelectorAll('*').forEach((el) => {
      //   if (el.scrollHeight > el.clientHeight) {
      //     el.scrollTop = el.scrollHeight;
      //   }
      // });

      // Grab the rendered section after Vue has populated it
      const element = document.querySelector(`#${elementId}`);

      if (!element) return alert('Nothing to export');

      const clone = element.cloneNode(true); // includes all rendered HTML

      // Clone stylesheets
      const styles = Array.from(document.styleSheets)
        .map((styleSheet) => {
          try {
            if (styleSheet.href) {
              return `<link rel="stylesheet" href="${styleSheet.href}">`;
            } else if (styleSheet.cssRules) {
              const rules = Array.from(styleSheet.cssRules)
                .map((rule) => rule.cssText)
                .join('\n');
              return `<style>${rules}</style>`;
            }
          } catch (e) {
            return ''; // Skip CORS stylesheets
          }
        })
        .join('\n');

      const html = `
        <!DOCTYPE html>
        <html>
        <head>
          <meta charset="UTF-8">
          <title>Shared Page</title>
          ${styles}
           <style>
          html, body {
            height: 100vh;
            margin: 0;
            overflow-y: auto;
          }
        </style>
        </head>
        <body>${clone.outerHTML}</body>
        </html>
      `;

      // const blob = new Blob([html], { type: 'text/html' });
      // const url = URL.createObjectURL(blob);
      // const link = document.createElement('a');
      // link.href = url;
      // link.download = 'growth-page.html';
      // link.click();

      this.saveSharedPage({
        companyId,
        html: html,
      });
    },
    saveSharedPage(payload) {
      const growthFrame = payload.html;
      const companyId = payload.companyId;

      shareHtmlUrl(growthFrame, companyId)
        .then((response) => {
          console.log('Shared page saved:', response);
        })
        .catch((error) => {
          console.error('Error saving shared page:', error);
          this.$toast({
            title: 'Failed to save shared page. Please try again.',
            description: ``,
            status: 'error',
            position: 'top',
            duration: 3000,
          });
        });
    },
  },
};
